export default "__VITE_ASSET__ZBOrleMe__"